import * as R from 'ramda'
import { useSelector } from 'react-redux'
import { CachedRoomPermissions } from '$logic/user-permissions/types'
import { RootState } from '$setup/redux'

const userPermissionsSelector = (state: RootState) => state.main.userPermissions
export function useCachedUserPermissions() {
  return useSelector(userPermissionsSelector)
}

const userPermissionsInRoomSelector = (roomId: string) => (state: RootState) =>
  state.main.userPermissions[roomId]
const memoizedUserPermissionsInRoomSelector = R.memoizeWith(
  x => x,
  userPermissionsInRoomSelector,
)

export function useCachedUserPermissionsInRoom(
  roomId: string,
): CachedRoomPermissions | undefined {
  return useSelector(memoizedUserPermissionsInRoomSelector(roomId))
}
